import { Edit, SimpleForm, useTranslate } from 'react-admin';
import { ContractEditFormContents, ConfirmSaveToolbar } from '../../common_modules/components/ContractEditFormContents';
import useErrorHandler from '../../common_modules/hooks/useErrorHandler';

export const TermsSettingsEdit = () => {
  const handleError = useErrorHandler();
  const translate = useTranslate();

  const formProps = {
    fileInputLabel: translate('resources.terms-settings.fields.contents'),
    agreementChangeWarningText: translate('resources.terms-settings.fields.agreementChangeWarningText'),
    dialogTitle: translate('resources.terms-settings.fields.dialogTitle')
  };

  const Title = () => {
    return <span>{translate('resources.terms-settings.name')}</span>;
  }

  return (
    <Edit title={<Title />} mutationMode="pessimistic" mutationOptions={{ onError: handleError }} redirect={false}>
      <SimpleForm
        toolbar={
          <ConfirmSaveToolbar
            agreementChangeWarningText={formProps.agreementChangeWarningText}
            dialogTitle={formProps.dialogTitle}
          />
        }
        sx={{ maxWidth: '600px' }}
      >
        <ContractEditFormContents {...formProps} />
      </SimpleForm>
    </Edit>
  );
};
